import apiClient from "@/api/client";

export function postHeartbeat(): Promise<void> {
  return apiClient.post("/presence/heartbeat/").then(() => undefined);
}
